/* fiveaven : tiroir panier (snippet fv-panier). Remplace l'interface du panier Eurus en gardant son moteur :
   $store.xMiniCart.openCart / hideCart sont redirigés vers ce tiroir ; quantités, suppression et suggestions passent par
   l'API panier de Shopify (/cart/*.js) et les sections Eurus sont rafraîchies (compteur de l'en-tête).
   Écritures en file d'attente (assets/fv-cart.js, chargé juste avant) ; après chaque écriture, l'événement « fv:cart » porte le
   panier complet : le tiroir s'en sert pour suivre le récapitulatif sans relire /cart.js. */
(function () {
  "use strict";
  if (window.FVPanier) return;
  var el = document.getElementById("fvp"), voile = document.querySelector("[data-fvp-voile]");
  if (!el) return;
  var C = {};
  try { C = JSON.parse(document.getElementById("fvp-donnees").textContent); } catch (e) { C = {}; }
  var RACINE = String(C.racine || "/").replace(/\/?$/, "/"), SEUIL = C.seuil != null ? parseInt(C.seuil, 10) : 4900; // 0 = jamais offerte (territoires hors UE, snippets/fv-export)
  var zone = el.querySelector("[data-fvp-zone]"), liste = el.querySelector("[data-fvp-liste]"), reco = el.querySelector("[data-fvp-reco]"), rail = el.querySelector("[data-fvp-rail]");
  var valider = el.querySelector("[data-fvp-valider]"), validerBarre = el.querySelector("[data-fvp-valider-barre]"), barre = el.querySelector("[data-fvp-barre]"), nombre = el.querySelector("[data-fvp-nombre]");
  var panier = null, ouvert = false, dernierFocus = null;
  var occupes = {}; // lignes dont une modification attend encore son tour (grisées, même après un nouvel affichage)

  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  var fmt = function (cents, court) {
    var n = (cents || 0) / 100;
    var t = new Intl.NumberFormat("fr-FR", { style: "currency", currency: C.monnaie || "EUR", minimumFractionDigits: n % 1 ? 2 : 0 }).format(n).replace(/ | /g, " ");
    return court ? t.replace(" €", "€") : t;
  };
  var image = function (src, w) { if (!src) return ""; var u = src.indexOf("//") === 0 ? "https:" + src : src; return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w; };
  var ICO = {
    moins: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4.167 10h11.666"/></svg>',
    plus: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4.167v11.666M4.167 10h11.666"/></svg>',
    corbeille: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M13.333 5v-.667c0-.933 0-1.4-.181-1.756a1.667 1.667 0 0 0-.729-.729c-.356-.181-.823-.181-1.756-.181H9.333c-.933 0-1.4 0-1.756.181-.314.16-.569.415-.729.729-.181.356-.181.823-.181 1.756V5m1.666 4.583v4.167m3.334-4.167v4.167M2.5 5h15m-1.667 0v9.333c0 1.4 0 2.1-.272 2.635a2.5 2.5 0 0 1-1.093 1.093c-.534.272-1.235.272-2.635.272H8.167c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635V5"/></svg>'
  };

  // ---------- moteur Eurus : sections à rafraîchir (compteur de l'en-tête) ----------
  function store(n) { try { return window.Alpine && Alpine.store && Alpine.store(n); } catch (e) { return null; } }
  // fiveaven : sans « cart-drawer » (le tiroir Eurus, remplacé par celui-ci, n'est plus rendu à chaque appel panier)
  function sectionsEurus() { var h = store("xCartHelper"); return h && h.getSectionsToRender ? h.getSectionsToRender().map(function (x) { return x.id; }).filter(function (id) { return id !== "cart-drawer"; }) : []; }
  // signal pour les autres scripts du thème (quantités des fiches produit...) ; marqué fv : ce tiroir et le récapitulatif
  // ne relisent pas le panier pour autant (ils suivent l'événement « fv:cart »)
  function apresModif() { document.dispatchEvent(new CustomEvent("eurus:cart:items-changed", { detail: { fv: 1 } })); }
  function api(chemin, corps) {
    var s = sectionsEurus();
    if (corps && s.length) corps.sections = s;
    return fetch(RACINE + chemin, { method: corps ? "POST" : "GET", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: corps ? JSON.stringify(corps) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Erreur panier"); return j; }); });
  }
  // ---------- écritures : file d'attente partagée (assets/fv-cart.js), une seule à la fois, puis un seul événement « fv:cart » ----------
  // réponse = panier complet (cart/add.js compris). Repli si fv-cart.js manque : écriture directe, même résultat, même événement.
  function ecrire(chemin, corps) {
    if (window.FVCart) return window.FVCart.ecrire(chemin, corps, { source: "fvp", erreur: "Erreur panier" });
    return api(chemin, corps).then(function (j) {
      var h = store("xCartHelper");
      if (h && j && j.sections && h.reRenderSections) { try { h.reRenderSections(j.sections); } catch (e) { /* sections non rendues */ } }
      return chemin.indexOf("cart/add") === 0 ? api("cart.js") : j;
    }).then(function (p) { document.dispatchEvent(new CustomEvent("fv:cart", { detail: { panier: p, source: "fvp", chemin: chemin } })); return p; });
  }
  function lire() { return window.FVCart ? window.FVCart.lire("Erreur panier") : api("cart.js"); }
  // page Récapitulatif : c'est elle qui retire les échantillons (synchro de fv-recap.js), le tiroir ne s'en charge pas
  var SUR_RECAP = !!document.getElementById("fvr-donnees");

  // ---------- rendu ----------
  // échantillons offerts (lignes à 0 €, gérés par la page Récapitulatif) : affichés sous les produits, hors du compte d'articles
  var estEchantillon = function (it) { return it.product_type === "Échantillon offert"; };
  // un échantillon n'existe que s'il a été choisi (propriété _choix, page Récapitulatif) et qu'il reste au moins un produit :
  // sinon on le retire, pour que le compteur de l'en-tête ne compte jamais des échantillons seuls
  function nettoyer(p) {
    if (!p || !p.items || SUR_RECAP) return Promise.resolve(p);
    var produits = p.items.some(function (it) { return !estEchantillon(it); }), maj = {}, n = 0;
    p.items.forEach(function (it) { if (estEchantillon(it) && (!produits || !(it.properties && it.properties._choix))) { maj[it.key] = 0; n++; } });
    return n ? ecrire("cart/update.js", { updates: maj }) : Promise.resolve(p);
  }
  // échange de points : déduction attendue (prix des produits échangés), même si le panier n'a pas encore appliqué la réduction
  function ecartPoints(p) {
    var applique = 0, attendu = 0;
    p.items.forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) { if (a.discount_application && a.discount_application.title === "Échange de points") applique += a.amount || 0; });
      if (it.properties && it.properties._points) attendu += it.original_line_price || 0;
    });
    return Math.max(0, attendu - applique);
  }
  function rendre(p) {
    panier = p;
    var visibles = p.items.filter(function (it) { return !estEchantillon(it); });
    nombre.textContent = "(" + visibles.reduce(function (n, it) { return n + it.quantity; }, 0) + ")";
    if (!visibles.length) {
      liste.innerHTML = '<div class="fvp__vide">Ton panier est vide pour le moment.<br><a href="' + RACINE + 'collections/all">Découvrir nos soins</a></div>';
      reco.hidden = true;
    } else {
      liste.innerHTML = visibles.concat(p.items.filter(estEchantillon)).map(function (it) {
        var ech = estEchantillon(it), pts = it.properties && it.properties._points;
        var variante = it.variant_title && it.variant_title !== "Default Title" ? '<span class="fvp__variante">' + esc(it.variant_title) + "</span>" : ""; // sur la ligne de la marque : la ligne garde ses 128 px
        var barre = (it.original_line_price > it.final_line_price || pts) && it.original_line_price ? "<s>" + fmt(it.original_line_price, true) + "</s>" : "";
        return '<div class="fvp__ligne' + (occupes[it.key] ? " is-occupe" : "") + '" data-cle="' + esc(it.key) + '">' +
          '<a class="fvp__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(image(it.image, 200)) + '" alt="">' : "") + "</a>" +
          '<div class="fvp__texte"><span class="fvp__marque">' + esc(it.vendor) + variante + '</span><a class="fvp__nom" href="' + esc(it.url) + '" title="' + esc(it.product_title) + '">' + esc(it.product_title) + "</a>" +
          (ech ? "" : '<div class="fvp__actions"><span class="fvp__qte"><button type="button" data-fvp-qte="-1" aria-label="Retirer un">' + ICO.moins + "</button><span>" + it.quantity + '</span><button type="button" data-fvp-qte="1" aria-label="Ajouter un"' + (pts ? " disabled" : "") + ">" + ICO.plus + "</button></span>" +
          '<button type="button" class="fvp__suppr" data-fvp-suppr aria-label="Supprimer ' + esc(it.product_title) + '">' + ICO.corbeille + "</button></div>") + "</div>" +
          '<span class="fvp__prix">' + barre + (pts || ech || it.final_line_price === 0 ? "Offert" : fmt(it.final_line_price, true)) + (pts ? "<em>Échange · " + esc(pts) + " pts</em>" : "") + (ech ? "<em>Échantillon offert</em>" : "") + "</span></div>";
      }).join("");
      suggestions(p);
    }
    // livraison offerte
    var total = Math.max(0, p.total_price - ecartPoints(p));
    if (SEUIL > 0) {
      var reste = Math.max(0, SEUIL - total), pct = Math.min(100, Math.round((total / SEUIL) * 100));
      el.querySelector("[data-fvp-livraison-texte]").textContent = reste ? "Livraison offerte" : "Livraison offerte atteinte";
      el.querySelector("[data-fvp-restant]").textContent = reste ? fmt(reste, true) + " restants" : "";
      el.querySelector("[data-fvp-jauge]").style.width = (visibles.length ? pct : 0) + "%";
    }
    valider.textContent = visibles.length ? "Valider le panier - " + fmt(total) : "Valider le panier";
    valider.classList.toggle("is-off", !visibles.length);
    // fiveaven : même test que le bouton du pied (produits visibles) : des échantillons seuls ne permettent pas de valider
    if (validerBarre) { validerBarre.textContent = valider.textContent; validerBarre.classList.toggle("is-off", !visibles.length); }
    fondu();
  }
  // affichage d'un panier déjà connu (réponse d'une écriture, événement « fv:cart ») ; toute lecture partie avant est ignorée
  var tour = 0;
  function afficher(p) { tour++; rendre(p); return p; }
  // ombre du bas de liste : seulement s'il reste des produits à faire défiler
  function fondu() { zone.classList.toggle("a-suite", liste.scrollHeight - liste.scrollTop - liste.clientHeight > 2); }
  liste.addEventListener("scroll", fondu, { passive: true });
  window.addEventListener("resize", function () { if (ouvert) { fondu(); placer(); } });
  // mobile : le tiroir commence sous l'en-tête du site (bandeau + logo restent visibles, comme sur la maquette)
  function placer() {
    var bas = 0;
    if (window.innerWidth <= 640) {
      document.querySelectorAll(".shopify-section-group-header-group, body > header, #shopify-section-header").forEach(function (s) {
        var r = s.getBoundingClientRect();
        if (r.height > 0 && r.top < 200 && r.bottom > bas && r.bottom < window.innerHeight / 3) bas = r.bottom;
      });
    }
    var v = Math.max(0, Math.round(bas)) + "px";
    el.style.setProperty("--fvp-haut", v); voile.style.setProperty("--fvp-haut", v);
  }
  // mobile : bouton « Valider » épinglé en bas tant que celui du pied n'est pas visible
  if (barre && "IntersectionObserver" in window) {
    new IntersectionObserver(function (e) { barre.classList.toggle("is-cache", e[0].isIntersecting); }, { root: el, threshold: 0.6 }).observe(valider);
  } else if (barre) { barre.hidden = true; }
  /* 20/10/2026 (Andy) : « Vous pourriez aussi aimer » défile aux flèches et à la souris (on attrape une carte et on tire) */
  var fleches = el.querySelector("[data-fvp-fleches]"), fPrec = el.querySelector("[data-fvp-prec]"), fSuiv = el.querySelector("[data-fvp-suiv]");
  function pas() { var c = rail.querySelector(".fvp__carte:not([hidden])"); return c ? c.getBoundingClientRect().width + 10 : 240; }
  function etatFleches() {
    if (!fleches) return;
    var deborde = rail.scrollWidth > rail.clientWidth + 4; fleches.hidden = !deborde;
    if (fPrec) fPrec.disabled = rail.scrollLeft <= 2;
    if (fSuiv) fSuiv.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
  }
  if (fPrec) fPrec.addEventListener("click", function () { rail.scrollBy({ left: -pas(), behavior: "smooth" }); });
  if (fSuiv) fSuiv.addEventListener("click", function () { rail.scrollBy({ left: pas(), behavior: "smooth" }); });
  rail.addEventListener("scroll", etatFleches, { passive: true });
  window.addEventListener("resize", etatFleches); if ("ResizeObserver" in window) new ResizeObserver(etatFleches).observe(rail); // tiroir ouvert : le rail prend sa largeur
  if ("MutationObserver" in window) new MutationObserver(function () { requestAnimationFrame(etatFleches); }).observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ["hidden"] });
  var glisse = null, aGlisse = false;
  rail.addEventListener("pointerdown", function (e) {
    if (e.pointerType !== "mouse" || e.button !== 0 || e.target.closest("button")) return;
    glisse = { x: e.clientX, g: rail.scrollLeft, id: e.pointerId }; aGlisse = false;
  });
  rail.addEventListener("pointermove", function (e) {
    if (!glisse || e.pointerId !== glisse.id) return;
    var dx = e.clientX - glisse.x;
    if (!aGlisse && Math.abs(dx) > 5) { aGlisse = true; rail.classList.add("is-glisse"); try { rail.setPointerCapture(e.pointerId); } catch (x) {} }
    if (aGlisse) { rail.scrollLeft = glisse.g - dx; e.preventDefault(); }
  });
  function finGlisse(e) {
    if (!glisse) return;
    if (aGlisse) {
      try { rail.releasePointerCapture(glisse.id); } catch (x) {}
      var p = pas(), cible = Math.round(rail.scrollLeft / p) * p;
      rail.classList.remove("is-glisse"); rail.scrollTo({ left: cible, behavior: "smooth" });
    }
    glisse = null;
  }
  rail.addEventListener("pointerup", finGlisse); rail.addEventListener("pointercancel", finGlisse); rail.addEventListener("lostpointercapture", finGlisse);
  rail.addEventListener("click", function (e) { if (aGlisse) { e.preventDefault(); e.stopPropagation(); aGlisse = false; } }, true);
  rail.addEventListener("dragstart", function (e) { e.preventDefault(); });
  var recoPour = null;
  var variante = function (x) { return (x.variants || []).filter(function (y) { return y.available; })[0] || (x.variants || [])[0]; };
  var suggestionExclue = function (x) { return x.type === "Échantillon offert" || (x.tags || []).indexOf("fv-echantillon") > -1; };
  function suggestions(p) {
    var id = (p.items.filter(function (it) { return !estEchantillon(it); })[0] || p.items[0]).product_id;
    if (recoPour === id) { masquerDejaPresents(p); return; }
    recoPour = id;
    fetch(RACINE + "recommendations/products.json?product_id=" + id + "&limit=10&intent=related")
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) {
        // fiveaven : ni échantillons offerts ni produits à 0 € dans les suggestions
        var ps = (j.products || []).filter(function (x) { var v = variante(x); return x.available && !suggestionExclue(x) && v && v.price > 0; });
        if (!ps.length) { rail.innerHTML = ""; reco.hidden = true; return; }
        rail.innerHTML = ps.map(function (x) {
          var v = variante(x);
          return '<div class="fvp__carte" data-produit="' + x.id + '"><a class="fvp__carte-img" href="' + esc(x.url) + '"><img src="' + esc(image(x.featured_image, 120)) + '" alt="" loading="lazy"></a>' +
            '<div class="fvp__carte-texte"><span class="fvp__marque">' + esc(x.vendor) + '</span><a class="fvp__nom" href="' + esc(x.url) + '" title="' + esc(x.title) + '">' + esc(x.title) + '</a><span class="fvp__carte-prix">' + fmt(v.price, true) + "</span></div>" +
            '<button type="button" class="fvp__ajout" data-fvp-ajout="' + v.id + '" aria-label="Ajouter ' + esc(x.title) + ' au panier">' + ICO.plus + "</button></div>";
        }).join("");
        masquerDejaPresents(p);
      }).catch(function () { reco.hidden = true; });
  }
  function masquerDejaPresents(p) {
    var dans = {}; p.items.forEach(function (it) { dans[it.product_id] = 1; });
    var visibles = 0;
    rail.querySelectorAll("[data-produit]").forEach(function (c) { var cache = !!dans[c.getAttribute("data-produit")]; c.hidden = cache; if (!cache) visibles++; });
    reco.hidden = !visibles;
  }
  // lecture du panier ; si un panier plus récent a été affiché entre-temps (écriture, « fv:cart »), cette lecture est ignorée
  function charger() {
    var n = ++tour;
    return lire().then(function (p) { if (n === tour) rendre(p); })
      .catch(function () { if (n === tour) liste.innerHTML = '<p class="fvp__vide">Le panier ne se charge pas. Réessaie dans un instant.</p>'; });
  }

  // ---------- ouverture / fermeture ----------
  // p (facultatif) : panier déjà connu (réponse d'un ajout), affiché sans relire /cart.js
  function ouvrir(p) {
    var connu = p && p.items ? p : null;
    if (ouvert) { if (connu) afficher(connu); else charger(); return; }
    ouvert = true; dernierFocus = document.activeElement;
    voile.hidden = false; el.hidden = false; placer(); el.scrollTop = 0;
    requestAnimationFrame(function () { voile.classList.add("is-ouvert"); el.classList.add("is-ouvert"); fondu(); });
    document.documentElement.style.overflow = "hidden";
    (connu ? Promise.resolve(afficher(connu)) : charger()).then(function () { var x = el.querySelector(".fvp__x"); if (x) x.focus(); });
  }
  function fermer() {
    if (!ouvert) return;
    ouvert = false;
    voile.classList.remove("is-ouvert"); el.classList.remove("is-ouvert");
    document.documentElement.style.overflow = "";
    setTimeout(function () { if (!ouvert) { voile.hidden = true; el.hidden = true; } }, 300);
    var s = store("xMiniCart"); if (s) s.open = false;
    if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
  }
  voile.addEventListener("click", fermer);
  document.addEventListener("keydown", function (e) {
    if (!ouvert) return;
    if (e.key === "Escape") return fermer();
    if (e.key === "Tab") { // le focus reste dans le tiroir
      var f = [].slice.call(el.querySelectorAll("a[href], button:not([disabled])")).filter(function (x) { return x.offsetParent; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  function signaler(msg) { // message bref en haut de la liste (pas de fenêtre système)
    var m = el.querySelector(".fvp__erreur");
    if (!m) { m = document.createElement("p"); m.className = "fvp__erreur"; m.setAttribute("role", "alert"); zone.appendChild(m); }
    m.textContent = msg; clearTimeout(m._t); m._t = setTimeout(function () { m.remove(); }, 4000);
  }

  // ---------- actions ----------
  el.addEventListener("click", function (e) {
    if (e.target.closest("[data-fvp-fermer]")) return fermer();
    var ligne = e.target.closest(".fvp__ligne"), t;
    if (ligne && (t = e.target.closest("[data-fvp-qte], [data-fvp-suppr]"))) {
      var it = panier.items.filter(function (x) { return x.key === ligne.getAttribute("data-cle"); })[0]; if (!it) return;
      var q = t.hasAttribute("data-fvp-suppr") ? 0 : Math.max(0, it.quantity + parseInt(t.getAttribute("data-fvp-qte"), 10));
      var offert = !!(it.properties && it.properties._points), cle = it.key;
      ligne.classList.add("is-occupe"); occupes[cle] = (occupes[cle] || 0) + 1;
      var fait = false, libere = function () { if (fait) return; fait = true; if (occupes[cle] > 1) occupes[cle]--; else delete occupes[cle]; };
      ecrire("cart/change.js", { id: cle, quantity: q }).then(function (res) {
        if (offert) { // produit offert contre des points retiré : la réservation suit le panier (rien n'est débité avant la commande)
          var ids = (res.items || []).filter(function (x) { return x.properties && x.properties._points; }).map(function (x) { return String(x.variant_id); });
          fetch(RACINE + "apps/fiveaven/echanger", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ ids: ids }) }).catch(function () { /* nouvel essai au prochain échange */ });
        }
        return nettoyer(res).then(function (r) { libere(); apresModif(); afficher(r); });
      })
        .catch(function (err) {
          libere();
          var l = liste.querySelector('.fvp__ligne[data-cle="' + String(cle).replace(/["\\]/g, "\\$&") + '"]');
          if (l && !occupes[cle]) l.classList.remove("is-occupe");
          signaler(err.message);
        });
      return;
    }
    if ((t = e.target.closest("[data-fvp-ajout]"))) {
      t.disabled = true;
      ecrire("cart/add.js", { items: [{ id: +t.getAttribute("data-fvp-ajout"), quantity: 1 }] })
        .then(function (p) { apresModif(); afficher(p); }) // panier complet renvoyé par la file : pas de relecture
        .catch(function (err) { t.disabled = false; signaler(err.message); });
    }
  });

  // ---------- branchement sur le panier Eurus ----------
  function brancher() {
    var s = store("xMiniCart");
    if (!s) return false;
    s.openCart = function () { ouvrir(); };
    s.hideCart = function () { fermer(); };
    return true;
  }
  if (!brancher()) {
    document.addEventListener("alpine:initialized", brancher);
    var essais = 0, t = setInterval(function () { if (brancher() || ++essais > 40) clearInterval(t); }, 250);
  }
  // autres scripts du thème (ajout depuis une fiche produit...) : relecture si le tiroir est ouvert ; les signaux marqués fv
  // (ce tiroir, le récapitulatif) sont déjà suivis par « fv:cart » ci-dessous
  ["eurus:cart:items-changed", "eurus:cart:reload"].forEach(function (n) { document.addEventListener(n, function (e) { if (e.detail && e.detail.fv) return; if (ouvert) charger(); }); });
  // écriture faite ailleurs (récapitulatif, synchro des échantillons) : le panier complet arrive avec l'événement, sans relecture ;
  // les écritures de ce tiroir (source fvp) sont déjà affichées par l'action elle-même
  document.addEventListener("fv:cart", function (e) {
    var d = e.detail || {};
    if (d.source === "fvp" || !d.panier || !d.panier.items) return;
    if (ouvert) afficher(d.panier); // fermé : il relit le panier à l'ouverture
  });
  // ajout au panier depuis les vignettes produit (bouton .fv-ajout de snippets/card-product) : ajoute puis ouvre ce tiroir ;
  // produit à plusieurs variantes disponibles : ouvre la fiche pour choisir
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest(".fv-ajout"); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var fiche = b.getAttribute("data-fv-ajout-fiche");
    if (fiche) { window.location.href = fiche; return; }
    if (b.classList.contains("is-occupe")) return;
    b.classList.add("is-occupe");
    ecrire("cart/add.js", { items: [{ id: +b.getAttribute("data-fv-ajout"), quantity: 1 }] })
      .then(function (p) { apresModif(); b.classList.remove("is-occupe"); ouvrir(p); }) // panier complet : ouvert sans relecture
      .catch(function (err) { b.classList.remove("is-occupe"); ouvrir(); setTimeout(function () { signaler(err.message); }, 400); });
  }, true);
  // échantillons orphelins signalés par le Liquid (hors page Récapitulatif, qui fait sa propre mise à jour)
  if (C.nettoyer && !SUR_RECAP) {
    lire().then(function (p) { return nettoyer(p).then(function (r) { if (r !== p) apresModif(); }); }).catch(function () { /* nouvel essai à la page suivante */ });
  }

  window.FVPanier = { ouvrir: ouvrir, fermer: fermer, recharger: charger };
  // 22/10/2026 : le menu mobile (burger) s'ouvrait sous le tiroir panier (seul « Marques » dépassait) : ouvrir le menu ferme le panier
  function lierMenu() {
    var st = window.Alpine && window.Alpine.store && window.Alpine.store("xMobileNav");
    if (!st || typeof st.open !== "function") return false;
    if (st.__fvPanier) return true;
    var ouvrirMenu = st.open;
    st.open = function () { if (el.classList.contains("is-ouvert")) fermer(); return ouvrirMenu.apply(this, arguments); };
    st.__fvPanier = true; return true;
  }
  if (!lierMenu()) { document.addEventListener("alpine:initialized", lierMenu); window.addEventListener("load", lierMenu); }
})();
